export const TIME_CONTINUE_MODAL = (2 * 60 + 10) * 1000
